import { EntityTypeOld, ErrorStateOld } from "Store/interfaces/products";

export interface AkaHealthConfig {
  canPurchaseMemberInsurance: boolean;
  canPurchaseCoInsurance: boolean;
}

export interface AkaHealthConfigData {
  customerId: string;
}

export type AkaHealthConfigEntity = EntityTypeOld<
  AkaHealthConfig,
  OperationType
>;

export type AkaHealthConfigError = ErrorStateOld<OperationType>;

export enum OperationType {
  AKA_HEALTH_CONFIG = "AKA_HEALTH_CONFIG",
}
